import React, { ReactElement } from "react";

import ContactFlyoutForm from "components/ContactFlyoutForm/ContactFlyoutForm";
import { PropsWithEpiContent } from "types/Props";

import {
    Container,
    Heading,
    Links,
    LinkItem,
    Link,
} from "./ContactFlyoutSection.styled";
import ContactFlyoutSectionProps from "./ContactFlyoutSectionProps";

const ContactFlyoutSection = ({
    identifier,
    heading,
    items,
    contentId,
}: ContactFlyoutSectionProps): ReactElement => {
    const validItems =
        items?.filter(
            (item: PropsWithEpiContent) =>
                item.component === "LinkBlock" ||
                item.component === "ContactFlyoutFormBlock",
        ) ?? [];

    if (validItems.length === 0) {
        return <></>;
    }

    return (
        <Container id={identifier}>
            <Heading id={`link-list-header-${identifier}`}>{heading}</Heading>
            <Links aria-labelledby={`link-list-header-${identifier}`}>
                {items?.map((item, index) => {
                    return (
                        <LinkItem key={`link-list-item-${contentId}-${index}`}>
                            {item.component === "LinkBlock" && (
                                <Link
                                    gtmClickType="contact-flyout-cta"
                                    {...item}
                                    actionTheme="black"
                                />
                            )}
                            {item.component === "ContactFlyoutFormBlock" && (
                                <ContactFlyoutForm {...item} />
                            )}
                        </LinkItem>
                    );
                })}
            </Links>
        </Container>
    );
};

export default React.memo(ContactFlyoutSection);
